import React from 'react'
import AgoraSignallingComponent from 'src/components/AgoraSingallingComponent/AgoraSignallingComponent'
import { DISPATCH_EVENT_KEYS } from 'src/consumer/constants'
import { getAllRolesInBoolean } from 'src/mentor/layout/utils'
import { useLocation } from 'react-router-dom'

void React

const AgoraSignallingComponentForChamberScreens = () => {
  // This component is now only rendered on /kiosk/* routes (chamber screens)
  // Not rendered on /ca-home/* because clinic assistants use FLOW_RECEPTION_TABLET (no SCREEN_DEVICE_CONFIG_ID)
  // Not rendered on /clinic-home/* because clinic owners/managers don't have the required roles
  // No need for early returns - component is conditionally rendered in App.jsx
  const location = useLocation()
  
  let screenDeviceConfigId = null
  const kioskConfigString = localStorage.getItem('kiosk-config')
  const roleCaConfigString = localStorage.getItem('ROLE_CA_CONFIG')

  try {
    const parsedConfig = kioskConfigString
      ? JSON.parse(kioskConfigString)
      : roleCaConfigString
        ? JSON.parse(roleCaConfigString)
        : null
    screenDeviceConfigId = parsedConfig?.SCREEN_DEVICE_CONFIG_ID || null
  } catch (error) {
    console.warn('[CHAMBER SCREEN SIGNALING] Failed to parse screen config for signaling init', error)
  }
  const roles = getAllRolesInBoolean()

  // Don't initialize Agora for clinic assistants on calendar pages (they don't need video signaling)
  const isClinicAssistantOnCalendarPage = roles.isClinicAssistant && location?.pathname?.includes('/manage-bookings')
  
  const shouldInitialize =
    (roles.isClinicAssistant || roles.isChamberScreen || roles.isAumhumScreen) &&
    !isClinicAssistantOnCalendarPage &&
    Boolean(screenDeviceConfigId)
  
  console.log('[CHAMBER SCREEN SIGNALING] Initialization check:', {
    screenDeviceConfigId,
    isClinicAssistant: roles.isClinicAssistant,
    isChamberScreen: roles.isChamberScreen,
    isAumhumScreen: roles.isAumhumScreen,
    isClinicAssistantOnCalendarPage,
    shouldInitialize,
    pathname: location?.pathname,
    timestamp: new Date().toISOString()
  })
  
  if (!shouldInitialize) {
    console.warn('[CHAMBER SCREEN SIGNALING] Not initializing - shouldInitialize is false - Component will unmount and disconnect RTM!', {
      screenDeviceConfigId,
      isClinicAssistant: roles.isClinicAssistant,
      isChamberScreen: roles.isChamberScreen,
      isAumhumScreen: roles.isAumhumScreen,
      isClinicAssistantOnCalendarPage,
      pathname: location?.pathname,
      timestamp: new Date().toISOString()
    })
    return <></>
  }

  console.log('[CHAMBER SCREEN SIGNALING] Initializing AgoraSignallingComponent with deviceId:', screenDeviceConfigId)

  return (
    <AgoraSignallingComponent
      deviceId={screenDeviceConfigId}
      dispatchEventKey={DISPATCH_EVENT_KEYS.signalingEvent}
    />
  )
}

export default AgoraSignallingComponentForChamberScreens
